module.exports = __webpack_public_path__ + "ca6a95ec06d6fbac0433bfe83c260818.pdf";